<template>
    <modal @close="closeModal" dialog="modal-md" class="modal-reservations-filters">
        <div slot="title"></div>

        <div slot="body">
            <div class="row">
                <div class="col-12 d-flex justify-content-center px-5">
                    <div class="col-4 d-flex align-items-center" v-if="getSlimFilters && isDepartureDate">
                        <multiselect
                            ref="resourceFilter"
                            v-model="filters.resourceId"
                            :options="treatedResourceList"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="false"
                            placeholder="All Resources"
                            label="name"
                            track-by="id"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            class="w-100"
                        >

                            <template slot="selection" slot-scope="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length > 1" v-tooltip.auto="values.length + ' resources selected'">{{ values.length }} resources selected</span>
                                <span class="multiselect__single" v-else-if="values.length == 1 " v-tooltip.auto="values[0].name">{{values[0].name}} </span>
                            </template>

                            <template slot="option" slot-scope="props">
                                <i v-if="filters.resourceId.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                <i v-else class="far fa-square"></i>
                                <span v-tooltip.auto="props.option.name">{{props.option.name}}</span>
                            </template>
                        </multiselect>
                    </div>

                    <div class="d-flex align-items-center" :class="{'col-6': isPickupDate || isSalesDate, 'col-4': isDepartureDate}">
                        <multiselect
                            v-model="filters.categories"
                            :options="categories"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="false"
                            placeholder="All Categories"
                            label="name"
                            track-by="id"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            class="w-100"
                        >

                            <template slot="selection" slot-scope="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length > 1" v-tooltip.auto="values.length + ' status selected'">{{ values.length }} categories selected</span>
                                <span class="multiselect__single" v-else-if="values.length == 1 " v-tooltip.auto="values[0].name">{{values[0].name}} </span>
                            </template>

                            <template slot="option" slot-scope="props">
                                <i v-if="filters.categories.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                <i v-else class="far fa-square"></i>
                                <span v-tooltip.auto="props.option.name">{{props.option.name}}</span>
                            </template>
                        </multiselect>
                    </div>

                    <div class="d-flex align-items-center" :class="{'col-6': isPickupDate || isSalesDate, 'col-4': isDepartureDate}" v-if="treatedPaymentsStatusList && treatedPaymentsStatusList.length > 0">
                        <country-picker class="w-100" :allCountriesOption="true" :placeholder="'All Countries'" :openDirection="'bottom'" :selectedCountryValue="selectedCountry" :disabled="false" :allowEmpty="false" @input="updateCountry($event)"></country-picker>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12 d-flex justify-content-center px-5">
                    <div class="col-4 d-flex flex-column" v-if="eventStatusList && eventStatusList.length > 0">
                        <label class="bold mb-2 darker">Status</label>

                        <div 
                            v-for="status in eventStatusList" 
                            :key="status.id" 
                            class="d-flex align-items-center mr-3 mb-1"
                        >
                            <checkbox
                                :checked="isSelected('status', status.id)"
                                @input="toggle('status', status)"
                            >
                                <span class="white-space-nowrap">{{ status.description }}</span>
                            </checkbox>
                        </div>
                    </div>

                    <div class="col-4 d-flex flex-column" v-if="treatedPaymentsStatusList && treatedPaymentsStatusList.length > 0">
                         <label class="bold mb-2 darker">Payment Status</label>

                         <div 
                            v-for="payment in treatedPaymentsStatusList" 
                            :key="payment.id" 
                            class="d-flex align-items-center mr-3 mb-1"
                        >
                            <checkbox
                                :checked="isSelected('paymentStatus', payment.id)"
                                @input="toggle('paymentStatus', payment)"
                            >
                                <span class="white-space-nowrap">{{ payment.label }}</span>
                            </checkbox>
                        </div>
                    </div>

                    <div class="col-4 d-flex flex-column">
                         <label class="bold mb-2 darker">Other Filters</label>

                        <checkbox class="mr-3" v-model="filters.currentCheckboxPickup" v-if="!isPickupDate">
                            <span class="white-space-nowrap">Pickups</span>
                        </checkbox>

                        <checkbox class="mr-3" v-model="filters.currentCheckboxNote">
                            <span class="white-space-nowrap">Notes</span>
                        </checkbox>
                        
                    </div>
                </div>

            </div>
        </div>

        <div slot="footer">
            <div class="d-flex justify-content-end mb-4 mr-1 border-top pt-4">
                <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button type="button" class="btn ok wider" @click="save">Save</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    
    import Modal from './Modal'
    import Multiselect from 'vue-multiselect'
    import CountryPicker from '@/tools/CountryPicker'
    import _ from 'lodash'

    export default {
        data() {
            return {
                categories: [
                    { name: 'Adult', id: 1 }, 
                    { name: 'Children', id: 2 }, 
                    { name: 'Infant', id: 3 }, 
                    { name: 'Senior', id: 4 }, 
                    { name: 'Spectator', id: 5 }, 
                    { name: 'Student', id: 6 }, 
                    { name: 'Teenager', id: 7 }
                ],
                filters: {
                    resourceId: [],
                    paymentStatus: [],
                    countryId: null,
                    status: [],
                    currentCheckboxPickup: false,
                    currentCheckboxNote: false,
                    categories: []
                },
                originalFilters: null,
                selectedCountry: null,
                skipInitialCountryUpdate: true,
                reservationType: null
            }
        },
        created() {
            this.reservationType = this.getReservationsType;
            this.originalFilters = _.cloneDeep(this.getReservationsFilters);
            this.filters = _.cloneDeep(this.getReservationsFilters);
            
            if (this.filters.countryId != null) {
                this.selectedCountry = this.getCountries.find(
                    country => country.id === this.filters.countryId
                );

                this.skipInitialCountryUpdate = true;
            }
        },
        beforeDestroy() {
            this.resetReservationsType();
        },
        computed: {
            ...mapGetters([
                'getSelectedInvoice',
                'getSelectedReservation',
                'getSlimFilters',
                'getReservionStates',
                'getPaymentsStatusList',
                'getReservationsFilters',
                'getCountries',
                'getReservationsType'
            ]),
            treatedResourceList() {
                return this.getSlimFilters.resourceList || [];
            },
            eventStatusList() {
                return this.getReservionStates || [];
            },
            treatedPaymentsStatusList() {
                return this.getPaymentsStatusList || [];
            },
            isDepartureDate() {
                return this.reservationType === 1;
            },
            isPickupDate() {
                return this.reservationType === 2;
            },
            isSalesDate() {
                return this.reservationType === 3;
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'setReservationsFilters',
                'resetReservationsType',
                'resetReservationsFilters'
            ]),
            toggle(field, obj) {
                const arr = this.filters[field];
                const idx = arr.findIndex(item => item.id === obj.id);

                if (idx >= 0) {
                    arr.splice(idx, 1);
                } else {
                    arr.push(obj);
                }
            },
            isSelected(field, id) {
                return this.filters[field].some(item => item.id === id);
            },
            updateCountry(selectedCountry) {
                if (this.skipInitialCountryUpdate) {
                    this.skipInitialCountryUpdate = false;
                    
                    return;
                }

                this.selectedCountry = selectedCountry;
                this.filters.countryId = selectedCountry ? selectedCountry.id : null;
            },
            save() {
                this.setReservationsFilters(this.filters);
                this.eventHub.$emit('filtersSearch');
                this.closeModal();
            },
            cancel() {
                if (!_.isEqual(this.filters, this.originalFilters)) {
                    this.setReservationsFilters(_.cloneDeep(this.originalFilters));
                }

                this.closeModal();
            },
        },
        components: {
            Modal,
            Multiselect,
            CountryPicker
        }
    }
</script>

<style lang="scss">
    .modal-reservations-filters .modal-md .modal-footer {
        padding-top: 1rem;
    }
</style>



// WEBPACK FOOTER //
// ReservationsFilters.vue?fcf7c492